import React from 'react';
import TimeBlock from './TimeBlock';
import styled, { css } from 'styled-components';
import MessageBlock from './MessageBlock';
import { Image } from 'antd';

const MessageItemWrapper = styled.div`
  ${(props) =>
    props.isMe &&
    css`
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    `}
`;
const ContentRowWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: ${(props) => (props.isMe ? 'end' : 'start')};
`;

const MessageItem = ({
  isMe,
  name,
  message,
  date,
  readYN,
  unreadCount,
  urls,
  type = '',
  currentFileList = [],
  className = '',
  isVisible = true,
  userImage = 'girl.png',
  onClick = () => {},
  simpleAudioButton = false,
}) => {
  return (
    <>
      {isVisible && (
        <MessageItemWrapper
          isMe={isMe}
          className={
            (name !== 'AI봇'
              ? 'chat-detail user-chat-detail'
              : type === 'ai-talking-tutor' && name === 'AI봇'
              ? 'chat-detail ai-chat-detail'
              : '') +
            ' ' +
            className
          }
        >
          {/* <p className={name !== 'AI봇' ? "user-detail" : ""}>{isMe ? '나' : name}</p> */}
          <p className={name !== 'AI봇' ? 'user-detail' : type === 'ai-talking-tutor' && name == 'AI봇' ? 'ai-detail' : ''}>
            {isMe ? '나' : name}
          </p>
          <ContentRowWrapper
            className={type === 'ai-talking-tutor' ? 'msg_content_wrapper' : ''}
            isAITalkingTutor={type === 'ai-talking-tutor'}
          >
            {isMe ? (
              <>
                <TimeBlock date={date} unreadCount={unreadCount} />
                <MessageBlock
                  type={type}
                  isMe={isMe}
                  message={message}
                  urls={urls}
                  currentFileList={currentFileList}
                  simpleAudioButton={simpleAudioButton}
                />
              </>
            ) : (
              <>
                <MessageBlock
                  type={type}
                  isMe={isMe}
                  message={message}
                  urls={urls}
                  currentFileList={currentFileList}
                  simpleAudioButton={simpleAudioButton}
                />
                <TimeBlock date={date} />
              </>
            )}
          </ContentRowWrapper>
        </MessageItemWrapper>
      )}

      {!isVisible && (
        <ContentRowWrapper isMe={isMe}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: isMe ? 'row-reverse' : 'row',
              marginBottom: '10px',
              backgroundColor: isMe ? `#6bacdd` : `#ffffff`,
              padding: '10px 20px',
              borderRadius: !isMe ? '4px 35px 35px 35px' : '35px 4px 35px 35px',
              cursor: 'pointer',
            }}
            onClick={onClick}
          >
            <Image draggable="false" rootClassName="msg_image" src={userImage} width={50} height={50} preview={false} />
            <Image
              draggable="false"
              src="/images/talking-tutor/wave.png"
              height={50}
              width={100}
              style={{ borderRadius: '50%' }}
              preview={false}
            />
          </div>
        </ContentRowWrapper>
      )}
    </>
  );
};

export default MessageItem;
